import AccountPassFormErrorModel from './form-error.model';

class AccountPassFormModel {
    constructor() {
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.currentPassword = '';

        this.error = new AccountPassFormErrorModel();
    }

    setFormErrors(errors) {
        this.error.setFormErrors(errors);
    }

    toPayload() {
        let payload = {
            security: {
                currentPassword: this.currentPassword,
                hasChangePassword: true,
                password: {
                    first: this.newPassword,
                    second: this.confirmNewPassword
                },
            }
        };

        return payload;
    }

    reset() {
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.currentPassword = '';

        this.setFormErrors('');
    }
}

export default AccountPassFormModel;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/account-pass/model/form.model.js